import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { isProduction } from '@zapier/common-utils';

const syntheticUserAgent = /HeadlessChrome|PhantomJS|Selenium|Puppeteer|DatadogSynthetics|bot\/|crawler|spider/i;

export function isFaroCollectorRequest(url: string): boolean {
  const collectorUrl = process.env.FARO_COLLECTOR_URL;
  return !!collectorUrl && url.startsWith(collectorUrl);
}

export function initializeFaroRum() {
  if (typeof window === 'undefined') {
    return;
  }

  const url = process.env.FARO_COLLECTOR_URL;
  if (!url) {
    return;
  }

  const environment = window.location.hostname.includes('zapier-staging.com')
    ? 'staging'
    : isProduction()
    ? 'production'
    : undefined;
  if (!environment) {
    return;
  }

  if (syntheticUserAgent.test(window.navigator.userAgent)) {
    return;
  }

  initializeFaro({
    url,
    app: {
      name: 'dev-platform',
      version: process.env.COMMIT_HASH,
      environment,
    },
    sessionTracking: {
      samplingRate: environment === 'production' ? 0.1 : 1,
    },
    trackResources: true,
    ignoreUrls: [
      /https:\/\/browser-intake-[a-z0-9-]+\.(com|eu)\//,
      /https:\/\/[^/]+\.ingest\.([a-z]+\.)?sentry\.io\//,
      /https:\/\/rs\.fullstory\.com\//,
      /\/api\/v4\/tracking\/event/,
    ],
    instrumentations: getWebInstrumentations(),
  });
}
